import React, { useEffect, useState, useContext } from 'react'
import $ from "jquery";
import { set } from 'react-hook-form';
import { Form, InputGroup, Col, Button, Accordion, Card } from 'react-bootstrap';
import CustomSpinner from '../../generic/CustomSpinner';
// // Contexto
import { ModalContext } from "../../../context/modalContext";
import { ConfirmModalContext } from '../../../context/confirmModalContext';

import AddCursosCompania from '../formularios/AddCursosCompania';
import ComponentTable from '../../generic/ComponentsTable';
import { AlertBoxContext } from '../../../context/alertBoxContext';
import deleteIcon from "../../../assets/delete.png";
import Icon from '../../generic/Icon';


const CursosCompania = ({ idUsuario, accessLevel, ...props }) => {
  // console.log(idUsuario)

  // Contexto
  const { confirmModalSetShow, confirmModalSetTitle, confirmModalSetContent, confirmModalSetFunction } = useContext(ConfirmModalContext);

  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  //console.log(idUsuario.idUsuario)
  // Spinner
  const [loading, setLoading] = useState(false);

  const [cursosSTJ, setCursosSTJ] = useState({})
  const [cursos, setCursos] = useState({})
  

  const { addAlert } = useContext(AlertBoxContext);

  useEffect(() => {
    //obtengo la configuración y la reobtengo cuando se setee
    handleObtenerCursos()

  }, []);

  const obtenerCursos = () => {
    //console.log(`${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}`)
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}/0`,

      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  }

  const handleObtenerCursos = (addToExisting = false) => {

    setLoading(true);
    obtenerCursos()
      .then((response) => {
        // console.log(response)
        if (addToExisting) {
          //console.log(response)
          setCursos([...cursos, ...response.items]);
        } else {
          //console.log(response)
          setCursos(response.cursos);
        }
        setCursosSTJ(response.cursosSTJ)
        setLoading(false);
      })
      .catch(() => {
        //console.log('kaska')
        setLoading(false);
      });
  };

  /*const obtenerCursosSTJ = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/cursosstj`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  }*/
  const handlePostCurso = (data) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}/0`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };


  const handleForm = (datum) => {
        datum.userId= idUsuario
    modalSetShow(false);
    setLoading(true);
    handlePostCurso(datum)
      .then((response) => {
        setLoading(false);
        handleObtenerCursos()
        addAlert("Éxito", "Se ha añadido el curso correctamente", "success");
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", "Error al agregar el curso de la compañía", "danger");
      });

  }

  const handleDeleteCurso = (data) => {
    console.log(data)
    setLoading(true);
    //console.log(data)
    let settings = {
        url: `${process.env.REACT_APP_API_URL}/cursosstj/${idUsuario}/${data.id}`,
        method: "DELETE",
        xhrFields: {
            withCredentials: true,
        },
    };
     $.ajax(settings)
           .then(() => {
            addAlert("Exito", `Se ha eliminado el curso STJ`, "success");
            handleObtenerCursos(false)
            setLoading(false);
        })
        .catch(() => {
            setLoading(false);
            addAlert("Error", `No se ha podido eliminar el curso STJ`, "danger");
        });
}


  const procesaAnio = (row) => {
    return row?.coursesSTJ?.anio;
  }

  const procesaCurso = (row) => {
    return row?.coursesSTJ?.nombre;
  }

  const deleteTupla = (row) => {
    return (
        <Icon
            src={deleteIcon}
            onClick={() => {

                confirmModalSetTitle(`Eliminar curso STJ realizado`)
                confirmModalSetContent(<p> {`¿Está seguro de que quiere eliminar el curso STJ?`} </p>)
                confirmModalSetFunction(() => {
                    handleDeleteCurso(row)
                })
                confirmModalSetShow(true)

            }}
            className="d-flex m-auto"
        />
    );
};

  return (
    <>
      <div style={{ position: "relative" }}>
        <CustomSpinner animation={"border"} loading={loading} />
        <Accordion defaultActiveKey="1">
          <Card>
            <Card.Header>
              <Accordion.Toggle eventKey="0" as={Button} variant="link">
                Cursos organizados por la compañía STJ
              </Accordion.Toggle>
              {accessLevel >= 9 && (
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="float-right mr-4"
                  onClick={() => {
                    modalSetShow(true, "60%");
                    modalSetTitle("Añadir curso organizado por la Compañia STJ");
                    modalSetContent(<AddCursosCompania cursosSTJ={cursosSTJ} handleForm={handleForm}/>);
                  }}
                >
                  Añadir
                </Button>
              )}
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                <p>
                  <small>(Ordenado desde más reciente a más antiguo)</small>
                </p>
                {//console.log( cursos)
                }
                {cursos.length ? <ComponentTable
                  emptyTableComponent={<p className="m-2">{`No hay cursos realizados`}</p>}
                  headers={[
                    { name: "Año", value: procesaAnio },
                    { name: "Curso", value: procesaCurso },
                    { name: "Eliminar", value: deleteTupla },
                    // { name: "Fecha", value: processStartDate },
                    // { name: "Fecha de fin", value: processEndDate },
                  ]}
                  rows={cursos}
                />
                  : (
                    <p>No hay cursos realizados</p>
                  )}
                {/*   {cursos.length ? (
                cursos.map((situacion) => {
                  return <SituacionParticular accessLevel={accessLevel} key={situacion.id} situacionParticular={situacion} deleteSituacionParticularState={deleteSituacionParticular} />;
                })
              ) : (
                <p>No hay situaciones particulares actualmente.</p>
              )}*/}

              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    </>
  )
}

export default CursosCompania